/**
 * ShowroomListHeader Theme
 *
 * Styles for the showroom listing page header component
 * Features hero banner with title and country links with count badges
 */

/**
 * Get container styles with dynamic background image
 * @param {string} backgroundImage - Background image URL
 * @returns {Object} Container styles
 */
export const getContainerStyles = (backgroundImage) => ({
  position: 'relative',
  width: '100%',
  minHeight: {base: '320px', md: '400px', lg: '500px'},
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'flex-start',
  backgroundImage: backgroundImage ? `url('${backgroundImage}')` : undefined,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  overflow: 'hidden',
});

const ShowroomListHeader = {
  parts: [
    'container',
    'overlay',
    'content',
    'title',
    'countryLinksContainer',
    'countryLink',
    'countryLinkActive',
    'countBadge',
    'contentWrapper',
  ],
  baseStyle: {
    container: {
      position: 'relative',
      width: '100%',
      minHeight: {base: '320px', md: '400px', lg: '500px'},
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'flex-start',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      overflow: 'hidden',
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      bg: 'blackAlpha.400',
      zIndex: 1,
    },
    content: {
      position: 'relative',
      zIndex: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-end',
      textAlign: 'left',
      width: '100%',
      height: '100%',
    },
    title: {
      color: 'white',
      fontFamily: 'heading',
      fontSize: {base: '40px', lg: '72px'},
      fontWeight: '400',
      lineHeight: '120%',
      letterSpacing: {base: '-0.4px', lg: '-0.72px'},
    },
    countryLinksContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: {base: 4, md: 8, lg: 12},
    },
    countryLink: {
      display: 'inline-flex',
      alignItems: 'baseline',
      color: 'white',
      fontFamily: 'body',
      fontSize: {base: '16px', lg: '18px'},
      fontWeight: '400',
      textDecoration: 'none',
      transition: 'all 0.2s ease-in-out',
      _hover: {
        textDecoration: 'underline',
      },
      _focus: {
        outline: 'none',
      },
    },
    countryLinkActive: {
      display: 'inline-flex',
      alignItems: 'baseline',
      color: 'white',
      fontFamily: 'body',
      fontSize: {base: '16px', lg: '18px'},
      fontWeight: '400',
      transition: 'all 0.2s ease-in-out',
      _focus: {
        outline: 'none',
      },
    },
    countBadge: {
      color: 'whiteAlpha.650',
      fontSize: '10px',
      ml: 0.5,
      verticalAlign: 'super',
      lineHeight: 1,
      position: 'relative',
      top: '-0.5rem',
    },
    contentWrapper: {
      position: 'relative',
      zIndex: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-end',
      gap: {base: '26px', lg: '44px'},
      width: '100%',
      maxWidth: '1440px',
      mx: 'auto',
      paddingX: {base: '20px', lg: '80px'},
      paddingBottom: {base: '40px', lg: '70px'},
    },
  },
};

export default ShowroomListHeader;
